<template>
  <div>
    <slot name="title"/>
    <DateRangeDialog
      :options="{from: {min: tender.tenderPeriodTo}, to: {min: tender.tenderPeriodTo}}"
      :search.sync="deliveryPeriod.dateArray"
      :show-periods="false"
      @update:search="deliveryPeriod = $event">
      <template #activator="{ on, open: openDate }">
        <sFormItem
          label=""
          prop="deliveryPeriodFrom">
          <div
            class="delivery-period__row">
            <div
              class="delivery-period__chip"
              data-qa="date_chip"
              v-on="on"
              @click="openDate">
              <template v-if="!deliveryPeriod.dateFormatArray[0]">
                {{ $i18n.locale === 'en' ? '__/__/____' : '__.__.____' }}
              </template>
              <template v-else>
                {{ deliveryPeriod.dateFormatArray[0] }}
              </template>
            </div>
            <div
              class="delivery-period__chip"
              data-qa="date_chip"
              v-on="on"
              @click="openDate">
              <template v-if="!deliveryPeriod.dateFormatArray[1]">
                {{ $i18n.locale === 'en' ? '__/__/____' : '__.__.____' }}
              </template>
              <template v-else>
                {{ deliveryPeriod.dateFormatArray[1] }}
              </template>
            </div>
          </div>
        </sFormItem>
      </template>
    </DateRangeDialog>
  </div>
</template>
<script>
import DateRangeDialog from 'components/common/dialogs/DateRangeDialog.vue'

export default {
  name: 'DeliveryPeriod',
  computed: {
    deliveryPeriod: {
      get() {
        const deliveryPeriodFrom = this.tender?.deliveryPeriodFrom
        const deliveryPeriodTo = this.tender?.deliveryPeriodTo
        return {
          dateFormatArray: [
            deliveryPeriodFrom ? this.$d(new Date(deliveryPeriodFrom)) : '',
            deliveryPeriodTo ? this.$d(new Date(deliveryPeriodTo)) : '',
          ],
          dateArray: [
            deliveryPeriodFrom,
            deliveryPeriodTo
          ]
        }
      },
      set(newValue) {
        const formatValue = (value) => {
          if (!value) {
            return null
          }
          if (value.includes('T00:00:00')) {
            return value
          }
          return `${value}T00:00:00`
        }
        const result = this.$_.cloneDeep(this.tender)
        result.deliveryPeriodFrom = formatValue(newValue[0])
        result.deliveryPeriodTo = formatValue(newValue[1])
        this.$emit('update:tender', result)
      }
    }
  },
  components: {
    DateRangeDialog
  },
  props: {
    tender: {
      type: Object
    }
  },
}
</script>
<style scoped lang="scss">
.sFormItem.is-error .delivery-period__chip {
  border-color: var(--color-error) !important;
}
.delivery-period {
  &__row {
    display: grid;
    gap: 24px;
    grid-template-columns: auto auto;
  }
  &__chip {
    cursor: pointer;
    min-height: 40px;
    height: 40px;
    border-radius: 31px;
    background: var(--white-color) !important;
    border: 2px solid var(--color-main-green);
    padding: 11px 15px;
    line-height: 18px;
    box-sizing: border-box;
    width: 100%;
    font-size: inherit;
    color: var(--text-color);
  }
}
</style>
